// TODO: Remove this mock when be ready
export var mockAutomatedData = {
    metrics: {
        audience: {
            count: 7108,
            description: 'Regular clients, Prospective Clients',
        },
        sent: {
            campaigns: 139,
            since: 'Since Mar 20, 2025',
        },
        openRate: {
            percentage: 21.89,
            clients: 412,
        },
    },
};
